import { logger } from '../../../../utils/logger';
import { CXoneEventsSubscriptionContext, EventSubscription } from '../../subscription-context';

export function subscribeAudioElement(
  ctx: CXoneEventsSubscriptionContext
): EventSubscription | null {
  const audioElement = ctx.audioRef?.current;
  if (!audioElement) {
    return null;
  }

  const onError = (e: Event) => logger.error('[Events] Audio error:', e);
  audioElement.addEventListener('error', onError);

  return {
    unsubscribe: () => {
      audioElement.removeEventListener('error', onError);
    },
  };
}
